export const mainCategories = [
  'graffiti_posters_and_stickers', // 0
  'dumped_rubbish', // 1
  'bin_bags', // 2
  'cardboard_boxes', // 3
  'litter', // 4
  'dead_animals', // 5
  'bins', // 6
  'dog_poo', // 7
  'street_cleaning', // 8
];

export const subCategories = [
  {
    name: 'Graffiti',
    parentCategory: 'graffiti_posters_and_stickers',
    parentCategoryLabel: 'Graffiti, posters and stickers',
  },
  {
    name: 'Posters',
    parentCategory: 'graffiti_posters_and_stickers',
    parentCategoryLabel: 'Graffiti, posters and stickers',
  },
  {
    name: 'Stickers',
    parentCategory: 'graffiti_posters_and_stickers',
    parentCategoryLabel: 'Graffiti, posters and stickers',
  },
  {
    name: 'Construction / DIY',
    parentCategory: 'dumped_rubbish',
    parentCategoryLabel: 'Dumped rubbish',
  },
  {
    name: 'Household appliances',
    parentCategory: 'dumped_rubbish',
    parentCategoryLabel: 'Dumped rubbish',
  },
  {
    name: 'Furniture',
    parentCategory: 'dumped_rubbish',
    parentCategoryLabel: 'Dumped rubbish',
  },
  {
    name: 'Other dumped rubbish',
    parentCategory: 'dumped_rubbish',
    parentCategoryLabel: 'Dumped rubbish',
  },
  {
    name: 'Bin bags',
    parentCategory: 'bin_bags',
    parentCategoryLabel: 'Bin bags',
  },
  {
    name: 'Cardboard boxes',
    parentCategory: 'cardboard_boxes',
    parentCategoryLabel: 'Cardboard boxes',
  },
  {
    name: 'Litter',
    parentCategory: 'litter',
    parentCategoryLabel: 'Litter',
  },
  {
    name: 'Dog poo',
    parentCategory: 'dog_poo',
    parentCategoryLabel: 'Dog poo',
  },
  {
    name: 'Damaged, dirty or missing bin',
    parentCategory: 'bins',
    parentCategoryLabel: 'Bins',
  },
  {
    name: 'Full bin',
    parentCategory: 'bins',
    parentCategoryLabel: 'Bins',
  },
  {
    name: 'Street cleaning',
    parentCategory: 'street_cleaning',
    parentCategoryLabel: 'Street cleaning',
  },
  {
    name: 'Dead animals',
    parentCategory: 'dead_animals',
    parentCategoryLabel: 'Dead animals',
  },
];

export const questions = [
  /** key should not change/update as it is being used as a filter for question */
  {
    key: 'offensive',
    name: 'Is it offensive?',
    parentSubcategories: ['Graffiti', 'Posters', 'Stickers'],
    fieldType: 'Radio Button',
    response: '',
  },
  {
    key: 'howBig',
    name: 'How big is it?',
    parentSubcategories: ['Graffiti', 'Posters', 'Stickers'],
    fieldType: 'Option',
    response: '',
  },
  {
    key: 'surface',
    name: 'What surface is it on?',
    parentSubcategories: ['Graffiti', 'Posters', 'Stickers'],
    fieldType: 'Option',
    response: '',
  },
  {
    key: 'howMuch',
    name: 'How much is there?',
    parentSubcategories: [
      'Construction / DIY',
      'Household appliances',
      'Furniture',
      'Other dumped rubbish',
    ],
    fieldType: 'Option',
    response: '',
  },
  {
    key: 'howMany',
    name: 'How many are there?',
    parentSubcategories: ['Bin bags', 'Cardboard boxes'],
    fieldType: 'Option',
    response: '',
  },
  {
    key: 'binType',
    name: 'What type of bin is it?',
    parentSubcategories: ['Full bin', 'Damaged, dirty or missing bin'],
    fieldType: 'Option',
    response: '',
  },
  {
    key: 'binProblem',
    name: "What's wrong with the bin?",
    parentSubcategories: ['Damaged, dirty or missing bin'],
    fieldType: 'Option',
    response: '',
  },
  {
    key: 'cleaning',
    name: 'What needs cleaning away?',
    parentSubcategories: ['Street cleaning'],
    fieldType: 'Option',
    response: '',
  },
  {
    key: 'animal',
    name: 'What type of animal is it?',
    parentSubcategories: ['Dead animals'],
    fieldType: 'Option',
    response: '',
  },
  {
    key: 'isRecurring',
    name: 'Has the issue happened before?',
    parentSubcategories: ['Dog poo', 'Dead animals'],
    fieldType: 'Radio Button',
    response: '',
  },
];

export const fieldOptions = [
  {
    parentQuestion: 'How much is there?',
    options: [
      'Single item (1 bag)',
      'Car boot load (2-5 bags)',
      'Small van load (6-15 bags)',
      'Transit van load (16+ bags)',
    ],
  },
  {
    parentQuestion: 'How many are there?',
    options: [
      'Single item (1 bag)',
      'Car boot load (2-5 bags)',
      'Small van load (6-15 bags)',
      'Transit van load (16+ bags)',
    ],
  },
  {
    parentQuestion: 'How big is it?',
    options: [
      'Less than 1 square metre',
      '1 square metre to 3 square metres',
      '3 square metres plus',
    ],
  },
  {
    parentQuestion: 'What surface is it on?',
    options: [
      'Stone',
      'Brick',
      'Wood',
      'Tarmac',
      'Concrete',
      'Metal',
      'Plastic',
      'Glass',
      'Other/not known',
    ],
  },
  {
    parentQuestion: 'Is it offensive?',
    options: ['Yes', 'No'],
  },
  {
    parentQuestion: 'What needs cleaning away?',
    options: ['Other', 'Human fouling', 'Paint spillage', 'Oil or grease'],
  },
  {
    parentQuestion: 'What type of bin is it?',
    options: [
      'Black 4 wheeled bin',
      'Recycling bin',
      'Grit-salt bin',
      'Litter bin',
      'Food waste bin',
      'Large rubbish bin',
      'Micro recycling centre',
    ],
  },
  {
    parentQuestion: "What's wrong with the bin?",
    options: ['Replace bin', 'Repair bin', 'Clean bin'],
  },
  {
    parentQuestion: 'What type of animal is it?',
    options: ['Dog', 'Cat', 'Rodent', 'Bird', 'Fox', 'Badger', 'Other'],
  },
  {
    parentQuestion: 'Has the issue happened before?',
    options: ['Yes', 'No'],
  },
];

export const isRecurringIssueQuestionData = {
  textArea: {
    title: 'Please tell us when it has previously happened',
    description:
      'Please provide as much detail as possible, including who was involved, when it happened and where.',
    errorPath: 'whenRecurringHappened',
    id: 'whenRecurringHappened',
    maxLimit: 500,
  },
};
